import React from "react";
import { misEtapas, fechaHoraEn, paredEn, docDeEtapa, TIPO_DESCARGA_EN } from "@/lib/chofer";
import { InfoEtapa } from "@/components/chofer/InfoEtapa";
import { AgregarArchivo, ListaArchivos } from "@/components/chofer/AgregarArchivo";
import { TriangleAlert } from "lucide-react";
import { t } from "@/lib/i18n";
// Fix Q (2026-10-13): modo revisión. Se puede mirar cualquier etapa (anteriores, futuras o de otro chofer) sin cambiar su estado,
// sin borrar lo escrito y sin volver a registrar la salida. En una etapa propia que ya empezó se pueden adjuntar documentos que falten.
function Linea({ k, v, alerta = false }) {
  return (
    <p className={alerta ? "text-[15.5px] font-semibold text-danger flex items-start gap-1" : "text-[15.5px] text-ink"} data-testid={`rev-${k}`}>
      {alerta && <TriangleAlert className="h-4 w-4 mt-1 shrink-0" />}<span>{k}: {v}</span>
    </p>
  );
}
export function EtapaRevision({ carga, e, uid, onCarga }) {
  const ets = misEtapas(carga, uid);
  const numero = ets.findIndex((x) => x.clave === e.clave) + 1;
  const completada = !!e.salida_at;
  const empezada = !!e.llegada_at;
  const mia = e.chofer_id === uid;
  const zona = e.zona_horaria;
  const doc = docDeEtapa(carga, e.clave);
  const archivos = (carga.archivos || []).filter((a) => a.etapa === e.clave);
  const vigente = carga.eta_vigente;
  const eyebrow = completada ? t("Review · Step {numero} of {length}", { numero, length: ets.length }) : empezada ? t("In progress · Step {numero} of {length}", { numero, length: ets.length }) : t("Upcoming · Step {numero} of {length}", { numero, length: ets.length });
  return (
    <section className="bg-white border border-line rounded-[14px] p-4" data-testid={`etapa-revision-${e.clave}`}>
      <InfoEtapa carga={carga} uid={uid} e={e} eyebrow={eyebrow} mostrarProxima={false} />
      <div className="mt-4 space-y-1">
        <Linea k={t("Arrival")} v={empezada ? fechaHoraEn(e.llegada_at, zona) : t("Pending")} />
        {(completada || e.clave === "delivery" || e.clave === "return_chassis" || e.clave === "return_empty") && <Linea k={t("Departure")} v={completada ? fechaHoraEn(e.salida_at, zona) : t("Pending")} />}
        {e.chassis_reportado && <Linea k={t("Reported chassis")} v={e.chassis_reportado} />}
        {e.clave === "rail_pickup" && e.contenedor_reportado && (
          e.contenedor_coincide === false
            ? <Linea k={t("Reported container")} v={t("{contenedor} (does not match)", { contenedor: e.contenedor_reportado })} alerta />
            : <Linea k={t("Reported container")} v={t("{contenedor_reportado} · matches", { contenedor_reportado: e.contenedor_reportado })} />
        )}
        {e.clave === "empty_pickup" && e.contenedor_reportado && <Linea k={t("Reported container")} v={e.contenedor_reportado} />}
        {e.clave === "yard_stop" && e.espacio && <Linea k={t("Yard spot")} v={e.espacio} />}
        {e.clave === "delivery" && (
          <>
            {e.tipo_descarga && <Linea k={t("Unload type")} v={TIPO_DESCARGA_EN[e.tipo_descarga]} />}
            <Linea k={t("Delivery ETA")} v={vigente ? paredEn(vigente.eta_fecha, vigente.eta_hora, vigente.zona_horaria) : t("Not set")} />
            {e.descarga_terminada && <Linea k={t("Unloading")} v={t("finished; container is empty")} />}
          </>
        )}
        {e.clave === "return_empty" && e.vacio_devuelto && <Linea k={t("Empty container")} v={t("returned")} />}
        {e.clave === "return_chassis" && e.chassis_devuelto && <Linea k={t("Chassis")} v={t("returned")} />}
        {!empezada && <p className="text-[14px] text-ink-2 pt-1" data-testid="rev-no-empezo">{t("This step has not started yet.")}</p>}
      </div>
      {empezada && (
        <div className="mt-4">
          <p className="text-[14px] text-ink-2">{doc.nombre} · {doc.requerido ? t("required") : t("optional")}</p>
          {mia && (
            <div className="mt-1.5">
              <AgregarArchivo cargaId={carga.id} etapa={e.clave} tipo={doc.tipo} escaner={e.clave === "delivery"} etiqueta={doc.requerido && !doc.recibido ? t("Add missing PDF or photo") : t("Add PDF or photo")} onCarga={onCarga} />
            </div>
          )}
          <ListaArchivos archivos={archivos} zona={zona} />
          {archivos.length === 0 && doc.requerido && <p className="mt-1.5 text-[13.5px] font-semibold text-danger flex items-center gap-1" data-testid="rev-doc-pendiente"><TriangleAlert className="h-4 w-4" />{t(" Documents pending")}</p>}
        </div>
      )}
      {completada && <p className="mt-4 text-[13px] text-ink-2" data-testid="rev-nota">{t("Review does not change completed steps.")}</p>}
    </section>
  );
}
